import angular from 'angular';
import teamCalendarListComponent from './teamCalendarList.component';
import teamCalendarListCard from './teamCalendarListCard/teamCalendarListCard';

let teamCalendarListModule = angular.module('teamCalendarList', [
  teamCalendarListCard
])

  .component('teamCalendarList', teamCalendarListComponent)

  .name;

export default teamCalendarListModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarList.js